import React from 'react';

const CheckoutField = ({ label, id, required, error, className, ...props }) => (
  <div className="flex flex-col gap-1.5">
    <label htmlFor={id} className="text-[13px] font-semibold text-gray-600">
      {label} {required && <span className="text-red-500">*</span>}
    </label>
    <input
      id={id}
      className={`rounded-xl border bg-gray-50 px-4 py-3 text-sm text-gray-800 outline-none transition-all placeholder:text-gray-400 focus:bg-white focus:ring-2 ${error
          ? 'border-red-400 focus:border-red-400 focus:ring-red-400/10'
          : 'border-gray-200 focus:border-primary-500 focus:ring-primary-500/10'
        } ${className || ''}`}
      required={required}
      {...props}
    />
    {error && <p className="text-[11px] font-medium text-red-500">{error}</p>}
  </div>
);

export default CheckoutField;
